import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function SunIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 8.48605C11.8567 8.48605 8.48605 11.8574 8.48605 16.0007C8.48605 20.1439 11.8567 23.5153 16 23.5153C20.1426 23.5153 23.5139 20.1446 23.5139 16.0007C23.5139 11.8567 20.1426 8.48605 16 8.48605Z"
        fill="currentColor"
      />
      <path
        d="M16 6.27724C15.1902 6.27724 14.5339 5.6209 14.5339 4.81178V2.46612C14.5339 1.65633 15.1902 1 16 1C16.8098 1 17.4661 1.65633 17.4661 2.46612V4.81178C17.4661 5.6209 16.8091 6.27724 16 6.27724Z"
        fill="currentColor"
      />
      <path
        d="M16 25.7221C15.1902 25.7221 14.5339 26.3784 14.5339 27.1882V29.5332C14.5339 30.3437 15.1902 31 16 31C16.8098 31 17.4661 30.3437 17.4661 29.5332V27.1882C17.4661 26.3784 16.8091 25.7221 16 25.7221Z"
        fill="currentColor"
      />
      <path
        d="M22.8742 9.12511C22.3023 8.55248 22.3023 7.62445 22.8742 7.05182L24.533 5.39305C25.105 4.82108 26.0337 4.82108 26.6063 5.39305C27.1789 5.96568 27.1789 6.89438 26.6063 7.46634L24.9475 9.12511C24.3756 9.69774 23.4475 9.69774 22.8742 9.12511Z"
        fill="currentColor"
      />
      <path
        d="M9.12511 22.8756C8.55248 22.3023 7.62445 22.3023 7.05182 22.8756L5.39305 24.5337C4.82108 25.1056 4.82042 26.035 5.39305 26.607C5.96568 27.1789 6.89438 27.1789 7.46634 26.607L9.12511 24.9475C9.69774 24.3756 9.69774 23.4469 9.12511 22.8756Z"
        fill="currentColor"
      />
      <path
        d="M25.7221 16C25.7221 15.1902 26.3784 14.5339 27.1882 14.5339H29.5339C30.3437 14.5339 31 15.1902 31 16C31 16.8098 30.3437 17.4655 29.5339 17.4655H27.1882C26.3784 17.4655 25.7221 16.8098 25.7221 16Z"
        fill="currentColor"
      />
      <path
        d="M6.27724 16C6.27724 15.1902 5.6209 14.5339 4.81112 14.5339H2.46612C1.65633 14.5339 1 15.1902 1 16C1 16.8098 1.65633 17.4655 2.46612 17.4655H4.81178C5.6209 17.4655 6.27724 16.8098 6.27724 16Z"
        fill="currentColor"
      />
      <path
        d="M22.8742 22.8756C23.4469 22.3036 24.3756 22.3036 24.9475 22.8756L26.6063 24.5343C27.1789 25.1056 27.1789 26.035 26.6063 26.607C26.0337 27.1789 25.1056 27.1789 24.533 26.607L22.8742 24.9482C22.3016 24.3756 22.3016 23.4475 22.8742 22.8756Z"
        fill="currentColor"
      />
      <path
        d="M9.12511 9.12511C9.69774 8.55248 9.69774 7.62445 9.12511 7.05182L7.46634 5.39371C6.89371 4.82108 5.96568 4.82108 5.39305 5.39371C4.82042 5.96568 4.82042 6.89438 5.39305 7.46634L7.05182 9.12511C7.62445 9.69841 8.55248 9.69841 9.12511 9.12511Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
